import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter } from 'rxjs';

import { GerarRemessaJobService } from './gerar-remessa-job.service';
import { NotificacoesService } from './notificacoes.service';

const GERAR_REMESSA_ROUTE = '/arrecadacao/servicos/gerar-remessa';

@Injectable({ providedIn: 'root' })
export class GerarRemessaJobToastService {
    private readonly jobService = inject(GerarRemessaJobService);
    private readonly notificacoesService = inject(NotificacoesService);

    constructor() {
        this.jobService.restaurar();

        this.jobService.snapshot$
            .pipe(
                filter((job) => Boolean(job?.jobId) && (job?.status === 'DONE' || job?.status === 'ERROR')),
                distinctUntilChanged((a, b) => a?.jobId === b?.jobId && a?.status === b?.status),
                takeUntilDestroyed()
            )
            .subscribe((job) => {
                if (job?.status === 'DONE') {
                    this.notificacoesService.notificar({
                        severity: 'success',
                        summary: 'Remessa gerada',
                        detail: `Arquivo ${job.message ?? 'remessa.txt'} disponível. Acesse a tela para baixar.`,
                        link: GERAR_REMESSA_ROUTE,
                        linkLabel: 'Abrir tela',
                        life: 30000
                    });
                    return;
                }

                if (job?.status === 'ERROR') {
                    const semRegistros = job.errorMessage?.toLowerCase().includes('nenhum boleto');
                    this.notificacoesService.notificar({
                        severity: semRegistros ? 'warn' : 'error',
                        summary: semRegistros ? 'Sem registros' : 'Erro na remessa',
                        detail: job.errorMessage ?? 'Falha ao gerar o arquivo de remessa.',
                        link: GERAR_REMESSA_ROUTE,
                        linkLabel: 'Ajustar filtros',
                        life: 15000
                    });
                }
            });
    }
}

export const initializeGerarRemessaJobToasts = () => {
    inject(GerarRemessaJobToastService);
};
